import { BlockingModal } from 'components/BlockingModal/BlockingModal';
import React from 'react';
import styled from 'styled-components';

export const Content = styled.div`
  padding: 24px;
  color: #414141;

  font-family: Lato;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  text-align: center;
`;

interface SessionEndedModalProps {
  open: boolean;
  dismissCallback: () => void;
}

export const SessionEndedModal: React.FC<SessionEndedModalProps> = (props) => {
  const { open, dismissCallback } = props;

  return (
    <BlockingModal
      open={open}
      onClose={dismissCallback}
      title='Session ended'
      confirmBtn={{
        intent: 'primary',
        label: 'Okay',
        onClick: dismissCallback,
        width: '160px',
      }}
      maxWidth='xs'
      fullWidth
    >
      <Content>Your previous session has been ended. If this is a mistake, create a new session to continue tagging this game.</Content>
    </BlockingModal>
  );
};
